export interface Child extends HTMLElement {
    [key: string]: unknown;
}
